import storage from '../../lib/clients/local-storage-wrapper';
import { env } from './env';

const KEY = 'dev-overrides';

export interface DeviceOverride {
  isMobile?: boolean;
  isWebView?: boolean;
  isAndroid?: boolean;
}

export interface IframeOverride {
  isEmbedded?: boolean;
  isWidgetSdkEmbed?: boolean;
}

export type ConfigOverride = Record<string, string>;

export interface DevOverrides {
  device?: DeviceOverride;
  iframe?: IframeOverride;
  config?: ConfigOverride;
  crashAfterSubmit?: boolean;
}

export const loadDevOverrides = (): DevOverrides => {
  const raw = storage.getText(KEY);
  if (!raw) {
    return {};
  }
  try {
    return JSON.parse(raw) as DevOverrides;
  } catch {
    return {};
  }
};

export const saveDevOverrides = (overrides: DevOverrides): void => {
  storage.set(KEY, JSON.stringify(overrides));
};

export const clearDevOverrides = (): void => {
  storage.remove(KEY);
};

// UAT only, so a poisoned localStorage cannot crash a real payer after their number is submitted.
export const shouldCrashAfterSubmit = (): boolean =>
  env.UAT && Boolean(loadDevOverrides().crashAfterSubmit);
